import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { ValidationError } from "@cervval.js/common/src/forms/validationError";
import { RegisterValidator, Validator } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { anyObject, getProp } from "@cervval.js/common/src/tools/any.tools";
import { parseMinutesIntervals } from "@cervval.js/common/src/tools/interval.string.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import { render } from "micromustache";

/**
 * List of all english error messages by validator
 */
const _messagesEN = {
    minutesIntervalsValue: "{{ value }} isn't a valid format. Valid formats: '06:00-10:00', '13-18'"
};

type MinutesIntervalsEditorErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by validator
 */
const _messagesFR: MinutesIntervalsEditorErrorMessageRecord = {
    minutesIntervalsValue: "{{ value }} n'est pas une valeur acceptée. Formats valides: '06:00-10:00', '13-18'"

};

/**
 * MinutesIntervals error messages per language
 */
export const MINUTES_INTERVALS_EDITOR_ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};

/**
 * This validator ensures a value is a parsable minutesIntervals string
 * sample use in propertyConfig => validators: validatorEntry(MinutesIntervalsValidator, undefined) or validators: { minutesIntervals: true } (second option requires this class to be loaded)
 */
@RegisterValidator("minutesIntervals")
export class MinutesIntervalsValidator implements Validator<string> {

    /**
     * @returns true if property value is not null or undefined
     */
    public isValid(property: PropertyConfig, propertyValue: string, validatorParams: unknown, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        const valueParsed = parseMinutesIntervals(propertyValue);
        return valueParsed != null;
    }

    /**
     * @returns error message to show when not valid
     */
    public getError(lang: string, property: PropertyConfig, propertyValue: string, validatorParams: unknown, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, anyReallyAny>): ValidationError {
        // Get error message from i18n and compile with micromustache
        const errorMessage = getProp<anyObject>(MINUTES_INTERVALS_EDITOR_ERROR_MESSAGES, lang)[property.propertyName] ?? "";

        // Look at i18n from object keys
        const errorMessageData = {
            value: propertyValue
        };
        const errorMessageRendered = render(errorMessage, errorMessageData);
        return { errorMessage: errorMessageRendered };
    }

}